import { FunctionComponent, useState } from 'react'
import { message as antdMessage } from 'antd'
import axios from 'axios'
import styles from './FrameJohnCarter.module.css'

function validateEmail(email) {
  var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,100}$/
  return regex.test(email)
}

const FrameJohnCarter: FunctionComponent = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const handleSendMessage = async () => {
    if (!name) {
      antdMessage.error('Please enter your name!')
      return
    }
    if (!email) {
      antdMessage.error('Please enter your email!')
      return
    }
    if (!validateEmail(email)) {
      antdMessage.error('Please enter correct email!')
      return
    }

    if (!message) {
      antdMessage.error('Please enter message!')
      return
    }

    const result: any = await axios.post(
      'https://crypticlabs.org/wp-json/contact-form-7/v1/contact-forms/314/feedback',
      {
        _wpcf7: 314,
        _wpcf7_version: ' 5.6.4',
        _wpcf7_locale: 'en_US',
        _wpcf7_unit_tag: 'wpcf7-f314-p1077-o1',
        _wpcf7_container_post: 1077,
        _wpcf7_posted_data_hash: '0f77546587e7bf67e4da26c7fd055ae6',
        'full-name': name,
        email: email,
        message: message,
      },
    )
    if (result.message) {
      antdMessage.success(result.message)
    }
  }
  return (
    <>
      <div className={styles.rectangleBackground}>
        <a className={styles.textCopyright} href="mailto:contact@crypticlabs.org">
          <div className={styles.sendMessage}>Send message</div>
        </a>
        <div className={styles.contactcrypticlabsorg}>contact@crypticlabs.org</div>
      </div>
    </>
  )
}

export default FrameJohnCarter
